import DamageTypePage from "@/components/damageType/DamageTypePage";

const Betriebsunterbrechung = () => <DamageTypePage slug="betriebsunterbrechung" />;
export default Betriebsunterbrechung;
